import * as echarts from 'echarts'
import { addListener } from 'resize-detector'

/* eslint-disable */
export default {
  methods: {
    createChartBarGroup(blockId, chartData) {
      var myChart = echarts.init(document.getElementById(blockId))

      let option = this.createOptionsBarGroup(chartData)
      myChart.setOption(option)

      let zr = myChart.getZr()

      zr.on('click', e => {
        if (e.target == undefined) {
          this.destroyPopup()
        }
      })

      myChart.on('click', 'series', e => {

        let parent = null
        if (document.body.clientWidth > 768) {
          // parent = e.event.event.path[1]
          parent = document.getElementById(blockId)
        } else {
          parent = document.body
        }
        let div = this.createPopup(e, blockId)
        parent.appendChild(div)
        this.$emit('changeStyleButtonGoChild', { dataIndex: e.dataIndex, blockId: blockId })

        // this.$emit('go', {dataIndex: e.dataIndex, blockId: blockId})
      })

      addListener(document.getElementById(blockId), () => {
        myChart.resize()
      })
    },

    createOptionsBarGroup (chartData) {
      let _options = {
        title: {
          text: chartData.title || '',
          show: false
        },
        grid: {
          right: '3%',
          left: '110px',
          bottom: '50px',
          top: '3%',
          containLabel: false
        },
        yAxis: {
          type: 'value',
          name: chartData.y_axis.title || '',
          nameLocation: 'middle',
          nameGap: 80,
          nameTextStyle: {
            color: '#383838',
            fontSize: 14,
          },
          axisLabel: {
            textStyle: {
              color: '#9ba9b7',
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#9ba9b7'
            }
          }
        },
        xAxis: {
          data: this.createXAxisDataGroup(chartData),
          name: chartData.x_axis.title || '',
          nameGap: 25,
          nameLocation: 'center',
          nameTextStyle: {
            color: '#383838',
            fontSize: 14
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#9ba9b7'
            }
          },
          axisTick: {
            show: true,
            interval: 1
          },
          axisLabel: {
            inside: false,
            // rotate: 90,
            textStyle: {
              color: '#383838',
              fontSize: 12,
            },
          },
          z: 10
        },
        tooltip: {
          formatter: (params) => {
            if (params.seriesName !== 'shadow') {
              let _value = (params.value + '').split('.');
              _value = _value[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, '$1,');
              return params.name + ': ' + _value;
            }
          }
        },
        // dataZoom: [
        //   {
        //     type: 'inside'
        //   }
        // ],
        series: [
          { // For shadow
            name: 'shadow',
            type: 'bar',
            itemStyle: {
              // barBorderRadius: [0, 4, 4, 0],
              color: 'rgba(0,0,0,0)'
            },
            barGap: '-100%',
            barCategoryGap: '40%',
            data: this.craeateDataShadowGroup(chartData),
            animation: false
          },
          {
            type: 'bar',
            itemStyle: {
              // barBorderRadius: [0, 4, 4, 0],
              // color: '#00c0ef',
              color: 'groups' in chartData && chartData.groups[0] !== undefined && chartData.groups[0] !== null && 'color' in chartData.groups[0] ? chartData.groups[0].color : 'red'
            },
            emphasis: {
              itemStyle: {
                color: 'groups' in chartData && chartData.groups[0] !== undefined && chartData.groups[0] !== null && 'color' in chartData.groups[0] ? chartData.groups[0].color : 'red',
                opacity: 0.6
              }
            },
            data: this.createBarGroupData(chartData)
          }
        ]
      }
    
      return _options
    },

    createBarGroupData (chartData) {
      let _yValueColumn = chartData.y_axis.value_column

      let _data = []
      for (let i = 0; i < chartData.data.length; i++) {
        _data.push(chartData.data[i][_yValueColumn])
      }

      return _data
    },

    createXAxisDataGroup (chartData) {
      let _xValueColumn = chartData.x_axis.value_column
      let _xData = []

      for (let i = 0; i < chartData.data.length; i++) {
        _xData.push(chartData.data[i][_xValueColumn])
      }

      return _xData
    },

    craeateDataShadowGroup (chartData) {
      let _yValueColumn = chartData.y_axis.value_column
      let yMax = Math.max.apply(Math, chartData.data.map((o) => { return o[_yValueColumn] })) // поиск максимума
      let _shadowData = []

      for (let i = 0; i < chartData.data.length; i++) {
        _shadowData.push(yMax)
      }

      return _shadowData
    }

  }
}


// WEBPACK FOOTER //
// ./src/mixins/chartBarGroupMix.js